var features = require('diy/util/features');
var $ = require('jquery');

module.exports = function (_super)
{
    this.tabElementId = 'eh-background';
    this.imageCountLimit = jimdoData.emotionheader.background.imageCountLimit;
    this.thumbDimensions = jimdoData.emotionheader.background.thumbDimensions;
    this.defaultBgColor = jimdoData.emotionheader.background.defaultBgColor;

    this.model = _super.model;
    this.syncWithModel = null;

	var self = this;

	var MAX_IMAGES = 10;
	var imageLimitReachedMessage = jimdoData.messages.emotionheader.background.dialog.imageLimitReached.format(MAX_IMAGES);

	var $eheContent = _super.$eheContent,
		$saveModeOpts,
		$btnChangeImage,
		$fieldset,
		optionControlMapper = {},
        $carousel,
        $colorPickerContainer,
        $bgAltTag;

	this.init = function() {
        $bgAltTag = $('#eh-bg-alttag', $eheContent);

        this.syncWithModel = $.proxy(this.updateImage, this);

        this.initSourcePopup();

        // load Settings subview
        _super.switchView('Settings');

        this.initFields();
        //the colorPicker 1st
        this.initBgColorPicker();
        //then the carousels which might show the colorPicker
        this.initCarousel();

		this.setupChangeHandlers();

        /**
         * Make some SiteCatalyst tracking
         */
        $(document).trigger('diy-editor-makeWebsiteFit', {
            'condition': 'Visited',
            'name': 'Key Visual'
        });
	};

    this.initFields = function() {
        $fieldset = $('#eh-bg-fieldset');
        $fieldset.fieldset({ collapsed: true });

        $saveModeOpts = $('#eh-bg-save-mode-options');
        $saveModeOpts.radiogroup({selectedClass: 'eh-radio-item-selected'});

        //saveMode
        optionControlMapper['saveMode'] = {
            getValue: function(val) {
                return $saveModeOpts.radiogroup('value');
            },
            setValue: function(val) {
                // set new value and triggering the change event
                $saveModeOpts.radiogroup('value', val);
            }
        };
        $saveModeOpts.bind('change_radiogroup', function(e, val) {
            //stop syncing - this is a reset to default header
            self.stopCarouselModelSync();

            self.model.setSaveMode(val);
            if (val === 'default_header') {
                $carousel.diy_carousel('option', 'items', self.model.getImageList().slice(0))
            }
            self.startCarouselModelSync();
        });

        optionControlMapper['backgroundVisible'] =  {
            getValue: function() {
                return !$fieldset.fieldset('isCollapsed');
            },
            setValue: function(val) {
                $fieldset.fieldset('setCollapsed', val != 1);
                optionControlMapper['backgroundVisible'].valueChanged(val);
            },
            changeHandler: function() {
                $fieldset.bind('toggle.fieldset', function(e, show) {
                    if (show) {
                        var selectedItemData = $carousel.diy_carousel('getSelectedItem');
                        self.model.set({
                            backgroundVisible: 1,
                            bgColor: self.getItemBgColor(selectedItemData, $carousel)
                        });
                    } else {
                        self.model.set({
                            backgroundVisible:0,
                            bgColor: self.getItemBgColor(null, $carousel)
                        });
                    }

                    optionControlMapper['backgroundVisible'].valueChanged(show);
                });
            },
            valueChanged: self.backgroundVisibleHandler
        };

        if (_backgroundDisabledByLayout) {
            $fieldset.fieldset('setDisabled', true);
            self.backgroundVisibleHandler(0);
        }

        _super.initSlider({option: 'height', id: '#eh-height-slider', min: 1, max: 1000,	step: 1,
            formatter: function (val) {
                return val + 'px';
            }
        }, optionControlMapper, this.model);

        optionControlMapper['heightEditable'] = {
            setValue: function(val) {
                $('#eh-height-slider').diy_slider('option', 'disabled', !val);
            }
        };

        optionControlMapper['backgroundAltTag'] = {
            getValue: function () {
                return $bgAltTag.val();
            },
            setValue: function (val) {
                if(val !== $bgAltTag.val()) {
                    $bgAltTag.val(val);
                }
                $('#emotion-header-img').attr('alt', val);
            },
            changeHandler: function () {
                $bgAltTag.bind('keyup', function () {
                    self.model.set('backgroundAltTag', $bgAltTag.val());
                });
            }
        };
    };

    this.initSourcePopup = function() {
        $btnChangeImage = $('#eh-bg-change-image');
        var changeImageHandler;
        var tooltipTimeout;

        changeImageHandler = function(){
            if ($carousel.diy_carousel('getItemsNo') >= MAX_IMAGES) {
                if (!tooltipTimeout) {
                    $btnChangeImage.diy_tooltip({
                        cls : 'diy-alert-tooltip ',
                        content: imageLimitReachedMessage,
                        triggerMode: 'none'
                    });
                    $btnChangeImage.diy_tooltip('show');
                }
                tooltipTimeout && clearTimeout(tooltipTimeout);
                tooltipTimeout = setTimeout(function(){
                    $btnChangeImage.diy_tooltip('destroy');
                    tooltipTimeout = null;
                }, 3000);
            } else {
                openFilemanager();
            }
        }
        $btnChangeImage.click(changeImageHandler);
    }

	this.backgroundVisibleHandler = function (val) {
	    if (val && !_backgroundDisabledByLayout) {
            //show background editable area
            $fieldset.fieldset('setCollapsed', false);
			//if carousel is initialized while collapsed
			//the buttons are not correctly refreshed
            $carousel.diy_carousel('refresh');
            $('#eh-editor .feature-guidance-help-button').show();
        } else {
            $fieldset.fieldset('setCollapsed', true);
            $('#eh-editor .feature-guidance-help-button').hide();
        }
    };

	this.setupChangeHandlers = function() {
		for (option in optionControlMapper) {
			if(optionControlMapper[option].changeHandler) {
				optionControlMapper[option].changeHandler();
			}
		}
    };

	this.switchSubView = function(subViewName) {
		switch (subViewName) {
            case 'Settings':
				return $('#eh-bg-image-editor-control');
				break;
		}
	};

	this.updateView = function(model, data, changed)
	{
        for(var option in changed) {
            var value = changed[option];
            if(optionControlMapper[option]) {
                optionControlMapper[option].setValue(value);
            }
        }
    };

    this.destroy = function() {/* TODO */ };

    var addImagesToCarousel = function(imagesData) {
        $carousel.diy_carousel('addItems', imagesData.map(function(imageData){
            return $.extend({}, self.model.bgImageDefaultSettings, imageData);
        }), -1, false /* no scroll */);
    };

    var updateChangeImageStatus = function() {
        if ($carousel.diy_carousel('getItemsNo') >= MAX_IMAGES) {
            $btnChangeImage.addClass('disabled');
        } else {
            $btnChangeImage.removeClass('disabled');
        }
    };

    var openFilemanager = function() {
        // First determine the background color for the patterns color picker
        // which corresponds to the currently selected image in the carousel
        var bgColor, sources;
        if (_backgroundColorDisabledByLayout) {
            bgColor = null; // transparent
        } else {
            if ($carousel.diy_carousel('getItemsNo') > 0) {
                bgColor = self.getItemBgColor($carousel.diy_carousel('getSelectedItem'), $carousel);
            } else {
                bgColor = self.model.getBgColor() ? self.model.getBgColor() : self.defaultBgColor;
            }
        }

        var insertStorageItems = function (items, succClb, errClb){
            var itemsIds = items.map(function (item) {
                return item.getId();
            });

            jQuery.ajax({
                type: 'POST',
                url: '/app/module/emotionheader/link-storage-files',
                data: {
                    pageId: _super.pageId,
                    storageFileIds: itemsIds
                },
                success: function (response, status, jqXHR) {
                    if (response.success) {
                        var images = response.data.images;

                        addImagesToCarousel(images.map(function (image) {
                            return {
                                backgroundSourceType: 'ImageUpload',
                                thumbSrc: image.thumbSrc,
                                sourceThumbSrc: image.sourceThumbSrc,
                                previewSrc: image.previewSrc,
                                uploadedImageId: image.imageId,
                                backgroundAnimated: image.backgroundAnimated
                            }
                        }));

                        succClb();
                    } else {
                        errClb(response);
                    }
                },
                error: function (jqXHR, status, errorThrown) {
                    errClb(errorThrown);
                }
            });
        }

        sources = {
            keyvisuals: function(items, succClb, errClb) {
                addImagesToCarousel(items.map(function(item) {
                    var itemId = item.getId(), itemRes = item.getResource();
                    return {
                        backgroundSourceType: 'Gallery',
                        imageId: itemId.id,
                        imageVersion: itemId.version,
                        sourceThumbSrc: itemRes.sourceThumbSrc,
                        thumbSrc: itemRes.thumbSrc,
                        previewSrc: itemRes.previewSrc
                    };
                }));
                succClb();
            },
            patterns: {
                backgroundColor: bgColor,
                enableBgColorPicker: !_backgroundColorDisabledByLayout,
                callback: function(items, succClb, errClb) {
                    addImagesToCarousel(items.map(function(item) {
                        var itemId = item.getId(), itemRes = item.getResource();
                        return {
                            backgroundSourceType: 'Patterns',
                            patternId: itemId.id,
                            patternBw: itemId.tinge,
                            bgColor: itemId.backgroundColor,
                            sourceThumbSrc: itemRes.sourceThumbSrc,
                            thumbSrc: itemRes.thumbSrc,
                            previewSrc: itemRes.previewSrc
                        }
                    }));
                    succClb();
                }
            },
            storage: insertStorageItems,
            bigstock: {
                batchSize: 1,
                callback: insertStorageItems
            },
            '123rf': {
                batchSize: 1,
                callback: insertStorageItems
            }
        };

        sources.cms = {
            batchSize: 1,
            callback: function(items, succClb, errClb) {
                var itemsIds = items.map(function(item){
                    return item.getId();
                });

                jQuery.ajax({
                    type: 'POST',
                    url: '/app/module/emotionheader/import-cms-images',
                    data: {
                        pageId: _super.pageId,
                        cmsImageIds: itemsIds
                    },
                    success: function(response, status, jqXHR) {
                        if (response.success) {
                            var images = response.data.images;

                            addImagesToCarousel(images.map(function(image) {
                                return {
                                    backgroundSourceType: 'External',
                                    thumbSrc: image.thumbSrc,
                                    sourceThumbSrc: image.sourceThumbSrc,
                                    previewSrc: image.previewSrc,
                                    uploadedImageId: image.imageId,
                                    backgroundAnimated: image.backgroundAnimated
                                }
                            }));

                            succClb();
                        } else {
                            errClb(response);
                        }
                    },
                    error: function(jqXHR, status, errorThrown) {
                        errClb(errorThrown);
                    }
                });
            }
        };

        var alreadyExisting = $carousel.diy_carousel('getItemsNo');

        diy.editor.filemanager = new diy.editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            subSection: 'keyvisualsPhotos', // default opened
            maxSelection: MAX_IMAGES,
            alreadyExisting: alreadyExisting,
            sources: sources,
            callback: function(report) {
                if (report.successItems.length === 0) {
                    // TODO check if some error handling have to be done here
                } else {
                    // scroll to the first added
                    // alreadyExisting is exactly the index of first added
                    $carousel.diy_carousel('scrollToItem', alreadyExisting);
                    $carousel.diy_carousel('selectItem', alreadyExisting);
                }
            }
        });
    };

	this.showLoadingBox = function() {
    };

    this.hideLoadingBox = function() {
    };

    var $colorPicker,
    carouselOptions = {
        selectable: true,
        sortable: true,
        syncWidth: true,
        sortableOptions: {
            start: function(event, ui, $carousel) {
                self.stopCarouselTooltips($carousel);
            },
            stop: function(event, ui, $carousel) {
                self.initCarouselTooltips($carousel);
            }
        },
        itemCreate: function(event, data) {
            if (data.item.backgroundSourceType === 'Patterns' && !_backgroundColorDisabledByLayout) {
                //if item data is changed update bgColor and tooltip
                data.itemEl.bind('updatedItem', function (event, data) {
                    self.setBgColorOnCarouselItem(this, data.bgColor);
                });
                self.setBgColorOnCarouselItem(data.itemEl, data.item.bgColor);
            }

            jQuery('.carousel-item-del', data.itemEl).click(
                $.proxy(function() {
                    $(this).diy_carousel('deleteItemEl', data.itemEl);
                }, this)
            );
        },
        create: function() {
            self.initCarouselTooltips(this);
        },
        afterItemAdd: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            //select item & set to bg
            $(this).diy_carousel('selectItem', data.index);
        },
        afterItemsAdded: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            //select item & set to bg
            $(this).diy_carousel('selectItem', data.index);
        },
        afterItemSelect: function (event, data) {
            _super._ignoreDataChange = true;
            self.model.setBgImageSource(data.item.backgroundSourceType, $.extend({}, data.item, {
                bgColor: self.getItemBgColor(data.item, $(this))
            }));
            _super._ignoreDataChange = false;
        },
        afterItemDelete: function(event, data) {
            self.initCarouselTooltips(this);
            _super.triggerDataChanged();
            if ($(this).diy_carousel('getItemsNo') > 0) {
                //if no item selected
                if ($(this).diy_carousel('getSelectedItemIndex') < 0) {
                    //select previous item
                    $(this).diy_carousel('selectItem', Math.max(0, data.itemIndex - 1));
                }
            } else {
                self.model.resetBgImage();
            }
        }
    };

    this.setBgColorOnCarouselItem = function(itemEl, bgColor) {
        if (typeof bgColor === 'undefined') {
            return;
        }

        var $itemEl = $(itemEl);
        $itemEl.find('.thumb').css('background-color', '#' + bgColor);
    };

    this.initBgColorPicker = function() {
        $colorPickerContainer = $('.pattern-color-picker', $('#eh-view-wrapper-Background'));
        var $color = self.model.getBgColor() ? self.model.getBgColor() : this.defaultBgColor;

        // create and initialize the color picker
        $colorPicker = $colorPickerContainer.colorPicker({
            mode: 'button',
            color: '#' + $color,
            showButtons: true,
            onColorAccept: function (color) {
                self.model.set('bgColor', color, true);
            }
        });

        self.model.bind('change', function(foo, bar, changed, extra) {
            if (changed['bgColor']) {
                // change default and current bg color in the color picker;
                // but only if the call didn't come manually from the picker
                if (!(extra && true === extra['doNotSetColorPicker'])) {
                    $colorPicker.setColor(changed['bgColor'], false);
                }
            }
        });

        CC.EmotionHeader.bind('switchView', function(viewName) {
            if ($colorPicker.isColorButtonOpened()) {
                $colorPicker.abortColor();
            }
        });
    }

    this.updateImage = function (model, data, changed) {
        if (typeof changed.backgroundVisible !== 'undefined') {
            //skip update when switching between visible
            return;
        }

        var updatedData = {};
        $.each(changed, function(propName, value){
            if (model.isBgProperty(propName)) {
                updatedData[propName] = value;
            }
        });

        //nothing bg related changed
        if ($.isEmptyObject(updatedData)) {
            return;
        }

        var selectedIndex = $carousel.diy_carousel('getSelectedItemIndex');
        var item = $carousel.diy_carousel('getItem', selectedIndex);

        //now compare with the stored data in the carousel
        var copyOfUpdatedData = updatedData;
        $.each(copyOfUpdatedData, function(propName, value) {
            if (typeof item[propName] != 'undefined' && item[propName] == value) {
                delete updatedData[propName];
            }
        });

        //nothing new/changed
        if ($.isEmptyObject(updatedData)) {
            return;
        }

        //update carousel item
        $carousel.diy_carousel('updateItem', selectedIndex, updatedData);

        //console.log('updated list item no '+selectedIndex+' with', updatedData);
    };

    this.startCarouselModelSync = function() {
        //console.log('this.startCarouselModelSync');
        this.model.bind('change', this.syncWithModel);
    };

    this.stopCarouselModelSync = function() {
        //console.log('this.stopCarouselModelSync');
        this.model.unbind('change', this.syncWithModel);
    };

    /**
     * returns bgColor to use from list of images + model
     * when selecting an image that is not a pattern
     * @param Object $carousel item object
     * @return {string|Number} color
     */
    this.getItemBgColor = function(item, $carousel) {
        if (item && item.backgroundSourceType === 'Patterns') {
            return item.bgColor;
        }

        //return 1st pattern color in list
        var items = $carousel.diy_carousel('getItems');
        for (var i=0; i<items.length; i++) {
            if (items[i].backgroundSourceType === 'Patterns') {
                return items[i].bgColor;
            }
        }

        var currentColor = this.model.getBgColor();
        if (typeof currentColor !== 'undefined' && currentColor != '0') {
            return currentColor;
        }

        return this.defaultBgColor;
    };

    this.initCarousel = function() {
        $carousel = $('#eh-bg-carousel');
        var imageList = this.model.getImageList().slice(0);

        $carousel.diy_carousel($.extend({}, carouselOptions, {
            itemTemplate: '<div class="thumb" >'
                +'<div class="imageItem">'
                    +'<img class="gallery-preview" src="{thumbSrc}" />'
                +'</div>'
                +'<div class="tooltip-trigger"></div>'
                +'<div class="carousel-item-del"></div>'
            +'</div>'
            + '<div class="selected-arrow"></div>',
            maxWidth: (diy.editor.uiPreference.isPointerModeTouch() ? 435 : 455),
            items: imageList,
            afterRefreshItems: function(event, data) {
                self.initCarouselTooltips(this);
                //when items are refresh select 1st item
                $carousel.diy_carousel('selectItem', 0);
            },
            afterItemSelect: function(event, data) {
                carouselOptions.afterItemSelect.call(this, event, data);

                //show colorPicker just for patterns
                if (!_backgroundColorDisabledByLayout && data.item.backgroundSourceType === 'Patterns') {
                    $('#eh-color-picker-wrapper').show();
                } else {
                    $('#eh-color-picker-wrapper').hide();
                }

                $carousel.diy_carousel('scrollToItem', data.index);
            },
            afterItemDelete: function(event, data) {
                carouselOptions.afterItemDelete.call(this, event, data);
            }
        }));
        updateChangeImageStatus();
        $carousel.bind(
            'carouselafteritemadd carouselafteritemsadded carouselafteritemdelete carouselafterrefreshitems',
            function(){
                updateChangeImageStatus();
            }
        );

        //select 1st item
        $carousel.diy_carousel('selectItem', 0);

        this.model.bind('eh-save eh-cancel', $.proxy(this.stopCarouselModelSync, this));
        _super.bind('open', $.proxy(function() {
            //refresh items
            $carousel.diy_carousel('option', 'items', this.model.getImageList().slice(0));
            this.startCarouselModelSync();
        }, this));
        this.startCarouselModelSync();
    }

    this.stopCarouselTooltips = function(carouselEl) {
        var $carouselItemEl = $(carouselEl).find('.diy-carousel-items');

        if ($carouselItemEl.is(":diy-simpleTooltip")) {
            //refresh
            $carouselItemEl.diy_simpleTooltip('destroy');
        }
    };

    this.initCarouselTooltips = function(carouselEl) {
        var $carouselItemEl = $(carouselEl).find('.diy-carousel-items');

        if ($carouselItemEl.is(":diy-simpleTooltip")) {
            //refresh
            $carouselItemEl.diy_simpleTooltip('destroy');
        }

        $carouselItemEl.diy_simpleTooltip({
            anchorToTarget: false,
            trackMouse: true,
            delegate: 'div.tooltip-trigger',
            content: function(elem) {
                var data = $(carouselEl).diy_carousel('getItemFromEl',
                    $(elem.closest('div.diy-carousel-item'))
                );

                if (data.backgroundSourceType == 'Patterns') {
                    return '<a class="patterns-preview" style=\''+
                        'background: url(' + data.previewSrc + ') repeat scroll 0% 0% #' + data.bgColor +'; ' +
                        'width: ' + self.thumbDimensions.preview.width + 'px; height: ' +
                            self.thumbDimensions.preview.height + 'px; display: block;\' href="#"></a>';
                }

                return '<img src="' + data.previewSrc + '" />';
            },
            show: function() {
                var el = $(this);
                el.diy_simpleTooltip('getContentEl').find('img').one('load', function() {
                    el.diy_simpleTooltip('refresh');
                });
            },
            cls: 'diy-image-tooltip eh-keyvisual-tooltip',
            zIndex: 200000,
            position: {
                collision: 'fit'
            },
            fadeInDelay: 400
        });
    };

    this.getImageList = function() {
        return $carousel.diy_carousel('getItems').slice(0);
    },

    this.onShow = function () {
        // if carousel was initialised
        if (typeof $carousel !== 'undefined' && $carousel) {
            //sometimes after switching between from other EH headers we need to refresh carousel display
			//DHDIYE-3235: The list of images are displaying on vertical.
            $carousel.diy_carousel('refresh');
        }

        var bubbleEl = $('#eh-editor .feature-guidance-help-button');
        if (this.model.get('backgroundVisible') == 1) {
            bubbleEl.attr('data', 'header').show();
        } else {
            bubbleEl.attr('data', 'header').hide();
        }

        $(document).trigger('diy-editor-header-backgroundTabLoad')
    }
};




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.Background.js
 ** module id = 877
 ** module chunks = 0
 **/